import { useContext } from 'react';

import { CurrencyContext } from 'app/components/commons/Currency/CurrencyContext/CurrencyContext';
import { PictureComponentV2 } from 'app/components/commons/PictureComponentV2/PictureComponentV2';
import { useEmojis } from 'app/hooks/data/useEmojis';
import { useExperiencesCategories } from 'app/hooks/data/useExperience';
import type { ExtranetHotelExperience } from 'app/typings/core/extranet/hotel/experiences';

import { formatExperienceName } from '../../../../TabViews/ExperiencesTab/_components/utils';
import styles from '../ExperienceDiscount.module.scss';

import type { ExperiencePrices } from './experiencePricing';

type ExperienceLabelProps = {
  experience?: ExtranetHotelExperience;
  prices: ExperiencePrices;
};

export const ExperienceLabel = ({
  experience,
  prices,
}: ExperienceLabelProps) => {
  const { data: emojis } = useEmojis();
  const { data: experienceCategories } = useExperiencesCategories();
  const { currencyFormatter } = useContext(CurrencyContext);

  const emoji = emojis?.find((e) => e.id === experience?.emoji?.id);

  const categoryName = experienceCategories?.find(
    (cat) => cat.id === experience?.categoryId
  )?.name;

  const experienceName = experience
    ? formatExperienceName(experience, categoryName)
    : 'Experience';

  return (
    <div className={styles.leftPart}>
      <div className={styles.emoji}>
        <PictureComponentV2
          path={emoji?.pictureId ?? ''}
          alt={emoji?.alt}
          width={36}
          height={36}
        />
      </div>
      <div className={styles.experienceTexts}>
        <span>{experienceName}</span>
        {prices.isVariablePrice && (
          <span className={styles.experienceSubtitle}>
            Rate depends on the day (min {currencyFormatter(prices.minPrice)},
            max {currencyFormatter(prices.maxPrice)})
          </span>
        )}
      </div>
    </div>
  );
};
